import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import StyledEngineProvider from '@material-ui/core/StyledEngineProvider';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserView } from 'react-device-detect';
import App from './App';
// import { AuthProvider } from './contexts/JWTContext';
import { SettingsProvider } from './contexts/SettingsContext';
import AuthProvider from './contexts/AuthContext/AuthContext';
import LayoutProvider from './contexts/LayoutContext/LayoutContext';
import UserProvider from './contexts/UserContext';

declare global {
  interface Window {
    octadesk: {
      chat: {
        showApp: () => void;
        hideApp: () => void;
        hideButton: () => void;
        showButton: () => void;
        toggle: () => void;
      };
    };
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <StrictMode>
    {/* @ts-ignore */}
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <QueryClientProvider client={queryClient}>
            <SettingsProvider>
              <BrowserRouter>
                <LayoutProvider>
                  <UserProvider>
                    <AuthProvider>
                      <App />
                      {/* @ts-ignore */}
                      <BrowserView>
                        <ReactQueryDevtools initialIsOpen />
                      </BrowserView>
                    </AuthProvider>
                  </UserProvider>
                </LayoutProvider>
              </BrowserRouter>
            </SettingsProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </StrictMode>,
  document.getElementById('root'),
);
